import { useEffect } from 'react';
import { artService } from '../services/art.service';

function injectGtm(containerId) {
  if (!containerId || document.getElementById('ato-gtm-script')) return;
  const id = containerId.replace(/^GTM-/i, '');
  const script = document.createElement('script');
  script.id = 'ato-gtm-script';
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-${id}');`;
  document.head.appendChild(script);
}

function injectGa(measurementId) {
  if (!measurementId || document.getElementById('ato-ga-script')) return;
  const script = document.createElement('script');
  script.id = 'ato-ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
  const inline = document.createElement('script');
  inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());gtag('config', '${measurementId}');`;
  document.head.appendChild(inline);
}

export default function AnalyticsTags() {
  useEffect(() => {
    (async () => {
      try {
        const resp = await artService.getPublicTracking();
        if (resp.status !== 'success') return;
        const { ga_measurement_id, gtm_container_id } = resp.tracking || {};
        if (gtm_container_id) injectGtm(gtm_container_id.trim());
        if (ga_measurement_id) injectGa(ga_measurement_id.trim());
      } catch {
        // optional — no tracking configured
      }
    })();
  }, []);

  return null;
}
